// extracted by mini-css-extract-plugin
export default {"attachment":"Attachments_attachment__xEuxq","thumb":"Attachments_thumb__XARgJ","name":"Attachments_name__nNbEz"};